var map = {
	"./getSummarization-5e7fbf99-964d-42b1-8387-ce47fa19f4d9.json": 878,
	"./getSummarization-78f1d4a0-eba2-497d-8b82-ff7097380704.json": 7072,
	"./getSummarization-c5c78e85-74d1-4d16-be50-14b9ddb8d51f.json": 1041,
	"./getSummarization-default.json": 5627
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5095;